import { updateQueryStringParameters } from 'common/js/url-utils';
import { getOgAdContext } from '../js/environment-utils';
import { isFeatureEnable } from '../js/features-enabling';
import { sendAnalyticsTrack } from '../js/TrackAnalyticsHelper';
import { AnalyticsStore } from './AnalyticsStore';
import { MraidStore } from './MraidStore';

interface SkanStoreProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
}

export class SkanStore {
  private _isOpened: boolean = false;
  private _hasBeenOpened: boolean = false;
  private _clickUrl: string = '';
  private _mraidOpen: (url: string) => void = () => {};
  private _analyticsStore: AnalyticsStore;
  private _mraidStore: MraidStore;

  constructor({ analyticsStore, mraidStore }: SkanStoreProps) {
    this._analyticsStore = analyticsStore;
    this._mraidStore = mraidStore;
  }

  get canOpen(): boolean {
    return (
      isFeatureEnable('skan') &&
      window.mraid &&
      window.mraid.ogyOpenStoreKit &&
      !this._isOpened
    );
  }

  get canOpenAfterTimeout(): boolean {
    const { storekit } = getOgAdContext();
    if (storekit?.autoclick === 0) return false;
    return this.canOpen && !this._hasBeenOpened;
  }

  open(clickUrl: string, mraidOpen: (url: string) => void): boolean {
    if (!this.canOpen) return false;
    this._isOpened = true;
    this._hasBeenOpened = true;
    this._clickUrl = clickUrl;
    this._mraidOpen = mraidOpen;
    const clickTrackUrl = updateQueryStringParameters(clickUrl, { ot: true });
    this._analyticsStore.sendTrack(clickTrackUrl);
    this.sendStoreKitTrack('open');
    this.registerCloseEvent();
    window.mraid.ogyOpenStoreKit();
    return true;
  }

  private registerCloseEvent(): void {
    const closeCallback = (errorCode: number) => {
      window.mraid.removeEventListener('ogyCloseStoreKit', closeCallback);
      const hasErrorCode = errorCode != undefined;
      this._isOpened = false;
      if (!hasErrorCode) {
        this.sendStoreKitTrack('close');
        return;
      }
      this.sendStoreKitTrack('error', errorCode);
      // bt stands for "bypass tracks"
      const errorUrl = updateQueryStringParameters(this._clickUrl, {
        bt: true
      });
      this._mraidStore.manageMraidOpen(this._mraidOpen, errorUrl);
    };

    window.mraid &&
      window.mraid.addEventListener &&
      window.mraid.addEventListener('ogyCloseStoreKit', closeCallback);
  }

  private sendStoreKitTrack(event: string, errorCode?: number) {
    const params: any = {};
    if (errorCode) params.errorCode = errorCode;
    sendAnalyticsTrack(
      {},
      undefined,
      false,
      undefined,
      'store_kit_' + event,
      undefined,
      params
    );
  }
}
